import AppContext from 'App/AppContext';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { canUpdateTaskField, hasTaskUpdatePermission, TaskFieldTypes } from 'components/Tasks/TaskAuthHelper';
import { globalStackTokensGapExtraSmall, globalStackTokensGapMedium, userIcon } from 'globalStyles';
import { useContext, useState } from 'react';
import { ITaskAssignmentProps, TaskAssignment } from './TaskAssignment';
import { useIsInTaskDetailCallout } from './TaskDetailRow';
import { iconFontSize, readOnlyRowSpace } from './TaskDetailStyles';
import { IPFontIcon } from 'baseComponents';

interface ITaskDetailAssignmentProps extends ITaskAssignmentProps {}

export const TaskDetailAssignment = (props: ITaskDetailAssignmentProps) => {
  const isInCallout = useIsInTaskDetailCallout();
  const appContext = useContext(AppContext);
  const [canUpdate] = useState<boolean>(props.canUpdate ?? hasTaskUpdatePermission(props.orgTask, appContext));
  const isReadonlyPermissions =
    props.disabled || !canUpdateTaskField(props.orgTask, canUpdate, TaskFieldTypes.Permissions, appContext);
  const isReadonlyAssignee =
    props.disabled || !canUpdateTaskField(props.orgTask, canUpdate, TaskFieldTypes.Assignee, appContext);

  //
  // Main render
  //
  return (
    <IPStack
      horizontal
      tokens={appContext.isMobileView ? globalStackTokensGapExtraSmall : globalStackTokensGapMedium}
      verticalAlign="start"
      styles={isReadonlyPermissions && isReadonlyAssignee ? { root: { paddingBottom: readOnlyRowSpace } } : undefined}
    >
      {!isInCallout && (
        <IPStack.Item>
          {!appContext.isMobileView && <IPFontIcon iconName={userIcon.iconName} style={iconFontSize} />}
        </IPStack.Item>
      )}
      <IPStack.Item grow>
        <TaskAssignment
          orgTask={props.orgTask}
          task={props.task}
          canUpdate={canUpdate}
          isReadonlyPermissions={isReadonlyPermissions}
          isReadonlyAssignee={isReadonlyAssignee}
          onUpdate={props.onUpdate}
          getErrorMessage={props.getErrorMessage}
          hidePermissions={props.hidePermissions}
          hideAssignee={props.hideAssignee}
        />
      </IPStack.Item>
    </IPStack>
  );
};
